import { Link } from 'react-router-dom'
// import { imgBaseUrl } from 'lib/cloudinary' // imgBaseUrl + '/t_scale_150/' + 
import style from './style.module.css'
import Menu from './menu'
import { ReactComponent as InspireLogo } from 'assets/icon-inspire.svg'

const Header = ({ event }) => {
  
    return (
        <div className={style.header}>
          <Link to='/' className={style.headerBrand}>
            {!!event.logoUrl ? (
              <img src={event.logoUrl} alt={event.name} title={event.name} className={style.headerLogo} />
            ) : (
              // <div className={style.brandText}>{event.name}</div>
              <InspireLogo className={style.headerLogo} />
            )}
          </Link>
          <div className={style.headerSpacer} />
          <ul className={style.headerNav}>
            <li className={style.headerNavItem}>
              <Menu />
            </li>
          </ul>
        </div>
    )

}

export default Header